import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./Topbar/Topbar";
import Search from "./Search/search";
import Bookings from "./Bookings/Bookings";

function App() {
  return (
    <div className="layout">
      <BrowserRouter>
        <Topbar style={{'width':'100%'}}/>
        <Routes>
          <Route path="/search" element={<Search />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route exact path="/" element={<Navigate to="/search" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
